import React from 'react';

export const CTA = () => {
  return (
    <section className="rapid-fire-cta-section">
      <div className="rapid-fire-cta-text">
        <h2 className="rapid-fire-cta-title">Advanced Signal Processing</h2>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="1"
          viewBox="0 0 100 1"
          preserveAspectRatio="none"
        >
          <path d="M0 0.5H735" stroke="url(#paint0_linear_1053_2735)" />
          <defs>
            <linearGradient
              id="paint0_linear_1053_2735"
              x1="0"
              y1="1"
              x2="100"
              y2="1"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.509" stopColor="#FF2238" />
              <stop offset="1" stopColor="#FF2238" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <p className="rapid-fire-cta-description">
          More than just a diversity receiver, the rapidFIRE intelligently
          blends signals from two 5.8GHz A/V receiver modules, delivering an
          incredibly clear and interference-free FPV image. Its noise-detection
          algorithms eliminate tearing and rolling, ensuring a stable signal
          under all conditions for a flawless view.
        </p>
        <div className="dreamX__discover--button">
          <a
            href="https://shop.orqafpv.com/products/immersionrc-immersionrc-rapidfire-5-8ghz-video-receiver?_pos=1&_sid=0df80a809&_ss=r"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            buy now
          </a>
        </div>
      </div>
    </section>
  );
};
